import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_109: DocMigration = {
  maxSchemaVersion: "0.0.109",
  description: "Clear invalid references in electrical system",
  apply(json: any) {
    const {
      loads,
      controllers,
      embeddedGroups: roomGroups,
      independentLoadArrays: homeGroups,
      roomEmbeddedGroups: roomGroupsPerRoom,
      roomIndependentLoadArrays: homeGroupsPerRoom,
      roomClearRules,
    } = json.electricalSystem;

    const roomGroupsToDelete: string[] = [];
    for (const roomGroupId in roomGroups) {
      const roomGroup = roomGroups[roomGroupId];
      if (!roomGroup) {
        roomGroupsToDelete.push(roomGroupId);
        continue;
      }

      const { loadArrays, controllers: roomControllers } = roomGroup;
      const newLoadArrays: any[] = [];
      for (const loadArray of loadArrays) {
        switch (loadArray.type) {
          case "LOAD": {
            if (!loads[loadArray.id]) {
              continue;
            }
            break;
          }
          case "INDEPENDENT_BY_NAME_KEY": {
            if (!homeGroups[loadArray.independentArrayRefId]) {
              continue;
            }
            break;
          }
        }
        newLoadArrays.push(loadArray);
      }

      const newRoomControllers: string[] = [];
      for (const controllerId of roomControllers) {
        if (!controllers[controllerId]) {
          continue;
        }
        newRoomControllers.push(controllerId);
      }

      roomGroups[roomGroupId] = {
        ...roomGroups[roomGroupId],
        loadArrays: newLoadArrays,
        controllers: newRoomControllers,
      };
    }

    for (const roomGroupIdToDelete of roomGroupsToDelete) {
      delete roomGroups[roomGroupIdToDelete];
    }

    const homeGroupsToDelete: string[] = [];
    for (const homeGroupId in homeGroups) {
      const homeGroup = homeGroups[homeGroupId];
      if (!homeGroup) {
        homeGroupsToDelete.push(homeGroupId);
      } else if (homeGroup && homeGroup.loads) {
        const newLoads: string[] = [];
        for (const loadId of homeGroup.loads) {
          if (!loads[loadId]) {
            continue;
          }
          newLoads.push(loadId);
        }
        homeGroups[homeGroupId] = { ...homeGroups[homeGroupId], loads: newLoads };
      } else if (homeGroup && !homeGroup.loads) {
        homeGroup.loads = [];
      }

      for (const homeGroupIdToDelete of homeGroupsToDelete) {
        delete homeGroups[homeGroupIdToDelete];
      }
    }

    const roomGroupRoomIdsToDelete: string[] = [];
    for (const roomId in roomGroupsPerRoom) {
      if (!json.rooms[roomId]) {
        roomGroupRoomIdsToDelete.push(roomId);
        continue;
      }

      const roomGroupIdsToDelete: string[] = [];
      const roomGroupTable = roomGroupsPerRoom[roomId];

      if (!roomGroupTable) {
        roomGroupRoomIdsToDelete.push(roomId);
        continue;
      }

      for (const roomGroupId in roomGroupTable) {
        if (!roomGroups[roomGroupId]) {
          roomGroupIdsToDelete.push(roomGroupId);
        }
      }

      for (const roomGroupIdToDelete of roomGroupIdsToDelete) {
        delete roomGroupTable[roomGroupIdToDelete];
      }

      if (Object.keys(roomGroupTable).length === 0) {
        roomGroupRoomIdsToDelete.push(roomId);
      }
    }

    for (const roomIdToDelete of roomGroupRoomIdsToDelete) {
      delete roomGroupsPerRoom[roomIdToDelete];
    }

    const homeGroupRoomIdsToDelete: string[] = [];
    for (const roomId in homeGroupsPerRoom) {
      if (!json.rooms[roomId]) {
        homeGroupRoomIdsToDelete.push(roomId);
        continue;
      }

      const homeGroupIdsToDelete: string[] = [];
      const homeGroupTable = homeGroupsPerRoom[roomId];

      if (!homeGroupTable) {
        homeGroupRoomIdsToDelete.push(roomId);
        continue;
      }

      for (const homeGroupId in homeGroupTable) {
        if (!homeGroups[homeGroupId]) {
          homeGroupIdsToDelete.push(homeGroupId);
        }
      }

      for (const homeGroupIdToDelete of homeGroupIdsToDelete) {
        delete homeGroupTable[homeGroupIdToDelete];
      }

      if (Object.keys(homeGroupTable).length === 0) {
        homeGroupRoomIdsToDelete.push(roomId);
      }
    }

    for (const roomIdToDelete of homeGroupRoomIdsToDelete) {
      delete homeGroupsPerRoom[roomIdToDelete];
    }

    const clearRoomIdsToDelete: string[] = [];
    for (const roomId in roomClearRules) {
      if (!json.rooms[roomId]) {
        clearRoomIdsToDelete.push(roomId);
      }
    }

    for (const clearRoomIdToDelete of clearRoomIdsToDelete) {
      delete roomClearRules[clearRoomIdToDelete];
    }

    return json;
  },
};

export default migration_0_0_109;
